<script setup lang="ts"></script>

<template>
  <div class="docs-header__container container container-main py-2 md:py-[16px] bg-white z-10">
    <div class="flex items-center flex-col">
      <div class="flex w-full items-center xl:gap-[100px]">
        <router-link :to="{ name: '/home' }" class="mx-auto xl:mr-0 xl:mx-0 xl:shrink-0 max-[1280px]:ml-0">
          <figure>
            <img loading="lazy" src="/img/logo/logo-kids.svg" alt="logo" class="w-[72px] md:w-[92px] xl:w-[180px] xl:block hidden" />
            <img
              loading="lazy"
              src="/img/logo/logo-kids-mobile.svg"
              alt="logo-mobile"
              class="min-[350px]:w-[250px] w-[121px] xl:hidden block"
            />
          </figure>
        </router-link>
      </div>
    </div>
  </div>
  <slot></slot>
</template>

<style scoped lang="scss">
.docs-header {
  &__container {
    background-image: url("/img/docs/container-bg.png");
    background-repeat: no-repeat;
    background-size: 80%;
    background-position: top center;
    @include xl() {
      background: transparent;
    }
  }
}
</style>
